enum AccessOrderStatusesEnum {
  INCOMPLETE = 'INCOMPLETE',
  PROCESSING = 'PROCESSING',
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
}

export default AccessOrderStatusesEnum;
